import NaverLogin from './NaverLogin';
import KakaoLogin from './KakaoLogin';
import MobilePage from '../UiComponents/MobilePage';
import { Link, useSearchParams } from 'react-router-dom';
import './Auth.css';

const LoginPage = () => {
  const [searchParams] = useSearchParams()
  const successCallback = searchParams.get('successCallback') || searchParams.get('redirect')
  const failCallback = searchParams.get('failCallback')
  const source = searchParams.get('source')

  return <MobilePage className='storybook-page auth-page'>
    <main className='auth-content'>
      <header className='auth-intro'>
        <p className='book-eyebrow'><span aria-hidden='true'>✦</span> 우리 가족만의 이야기, 텔링파파</p>
        <h1 className='book-title'>반가워요.<br /><span>이야기를 함께 펼쳐요.</span></h1>
        <p className='book-description'>우리 아이가 주인공이 되고,<br />사랑하는 가족이 함께하는 동화.</p>
      </header>
      <figure className='auth-art'>
        <img src='/image/main/home-storybook.webp' alt='아이와 부모가 숲속에서 함께 동화책을 읽는 모습' width='1536' height='1024' fetchpriority='high' />
        <figcaption><span aria-hidden='true'>✦</span> 작은 이야기에서 시작되는, 커다란 상상.</figcaption>
      </figure>
      <section className='auth-signin' aria-labelledby='signin-heading'>
        <h2 id='signin-heading'>간편하게 시작하세요</h2>
        <p>처음 오셨나요? 소셜 계정으로 가입도 함께 진행돼요.</p>
        <div className='auth-provider-list'>
          <NaverLogin successCallback={successCallback} failCallback={failCallback} source={source} />
          <KakaoLogin successCallback={successCallback} failCallback={failCallback} source={source} />
        </div>
      </section>
      <footer className='auth-footer'>
        <nav aria-label='서비스 이용 안내'>
          <Link to='/terms'>이용약관</Link>
          <Link to='/privacy-policy'>개인정보처리방침</Link>
        </nav>
        <Link className='book-text-link' to='/fairytales?sample=true'>샘플 동화 먼저 둘러보기 <span aria-hidden='true'>↗</span></Link>
      </footer>
    </main>
  </MobilePage>
}

export default LoginPage
